import { FormInstance } from "antd";
import { useCallback } from "react";
import { useFormData } from "./useFormData";
import { useAppDispatch } from "../../../../store";
import {
  createTemplate,
  editTemplate,
} from "../../../../acions/administration/templates";

export const useSave = (
  parentId: string,
  form: FormInstance,
  close: () => void,
  reloadData: () => void,
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>,
  onValidationFail: (value: any) => void
) => {
  const dispatch = useAppDispatch();

  const onError = useCallback(
    (e: any) => {
      const errorData = e.response.data;

      errorData.errors && onValidationFail(errorData.errors);

      setIsDisabled(false);
    },
    [onValidationFail, setIsDisabled]
  );

  const { getFormData } = useFormData();

  const create = useCallback(
    async (isNew: boolean, req: any) => {
      try {
        await Promise.resolve(dispatch(createTemplate(req)));

        isNew ? form.resetFields() : close();
        reloadData();

        setIsDisabled(false);
      } catch (e: any) {
        onError(e);
      }
    },
    [dispatch, form, close, reloadData, setIsDisabled, onError]
  );

  const edit = useCallback(
    async (id: string, req: any) => {
      try {
        await Promise.resolve(dispatch(editTemplate(id, req)));

        close();
        reloadData();

        setIsDisabled(false);
      } catch (e: any) {
        onError(e);
      }
    },
    [close, dispatch, reloadData, setIsDisabled, onError]
  );

  const onSave = useCallback(
    async (isNew: boolean, id: string | null) => {
      try {
        const request = await form.validateFields();

        const formData = id
          ? getFormData(request)
          : getFormData(request, parentId);

        setIsDisabled(true);

        id ? edit(id, formData) : create(isNew, formData);
      } catch {
        setIsDisabled(false);
      }
    },
    [create, edit, form, getFormData, parentId, setIsDisabled]
  );

  return { onSave };
};
